'use client';

import { useLocale } from 'next-intl';
import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ProductCard } from '../cards';
import ProductCardSkeleton from '../cards/product-card-skeleton';
import ArrowIcon from '../icons/arrow-icon';

const ProductsSlider = ({
  products = [],
  isMutating,
  fromPdp,
  fromCartPopUp,
  page,
}) => {
  const [swiper, set_swiper] = useState(null);
  const [active, setActive] = useState(false);
  const [isLastProduct, setIsLastProduct] = useState(false);
  const locale = useLocale();

  return (
    <div
      className={`${fromPdp || fromCartPopUp ? '' : 'border-t-border border-t px-4.5'} relative`}
    >
      {active ? (
        <button
          onClick={() => swiper?.slidePrev()}
          aria-label={locale === 'en' ? 'Previous' : 'السابق'}
          className='absolute start-0 top-1/2 z-20 hidden size-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-black/20 hover:bg-black/40 lg:flex'
        >
          <ArrowIcon
            className={`text-white ${locale === 'en' ? 'rotate-90' : '-rotate-90'}`}
          />
        </button>
      ) : null}
      <div className='py-3 sm:py-2'>
        <Swiper
          onInit={(e) => set_swiper(e)}
          spaceBetween={6}
          breakpoints={
            fromCartPopUp
              ? {
                  640: {
                    slidesPerView: 1.5,
                    slidesPerGroup: 1,
                  },
                  768: {
                    slidesPerView: 1.8,
                    slidesPerGroup: 1.8,
                  },
                  1024: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                  },
                }
              : {
                  320: { spaceBetween: 6, slidesPerView: 1.5 },
                  640: { spaceBetween: 9, slidesPerView: 3 },
                  769: { spaceBetween: 12.5, slidesPerView: 3 },
                  1044: { spaceBetween: 14, slidesPerView: 5 },
                }
          }
          onSlideChange={(info) => {
            setIsLastProduct(info?.isEnd);
            info?.activeIndex === 0 ? setActive(false) : setActive(true);
          }}
        >
          {isMutating
            ? [...Array(12).keys()].map((info) => (
                <SwiperSlide key={info}>
                  <ProductCardSkeleton />
                </SwiperSlide>
              ))
            : products?.map((product, idx) => (
                <SwiperSlide key={product?.sku}>
                  <ProductCard
                    product={product}
                    priority={idx <= 6}
                    page={fromCartPopUp ? 'cart-popup' : page}
                    index={idx}
                  />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
      {!isLastProduct ? (
        <button
          onClick={() => swiper?.slideNext()}
          aria-label={locale === 'en' ? 'Next' : 'التالي'}
          className='absolute end-0 top-1/2 z-20 hidden size-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-black/20 hover:bg-black/40 lg:flex'
        >
          <ArrowIcon
            className={`text-white ${locale === 'en' ? '-rotate-90' : 'rotate-90'}`}
          />
        </button>
      ) : null}
    </div>
  );
};

export default ProductsSlider;
